import React, {useMemo} from 'react'
import {Box, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Icon from '@material-ui/icons/CheckBox'
import IconOff from '@material-ui/icons/HighlightOff';
import Tr from 'translations/Translations';
import {DemandValidationTr} from 'constants/DemandValidation';
import {isDemandModification, isDemandPreparing} from 'libs/getDemandStatus';
import DemandService from "services/DemandService";
import Button from "components/Button";
import isBzpAttachmentNoticeType from "libs/isBzpAttachmentNoticeType";
import RouterPath from "libs/RouterPath";
import NationalNoticeService from "services/NationalNoticeService";

const style = theme => ({
    root: {},
    icon: theme.components.icon,
    center: {
        textAlign: "center"
    }
})

function InformationSection(
    {
        classes,
        id,
        classesRoot,
        isPublishActive,
        isPreviewActive,
        isPreviewNoticeActive,
        isPreviewDemandPublicFormActive,
        isPublicOjsActive,
        isOjsProcessing,
        uncompletedSections,
        demandHeader,
        section,
        isBzpPublishActive,
        isBzpProcessing
    }) {

    const isPreparing = isDemandPreparing();
    const isModification = isDemandModification();

    const isBzpAttachmentNotice = useMemo(() => isBzpAttachmentNoticeType(demandHeader), [demandHeader]);

    const openBzp = () => {
        let a = document.createElement('a');
        a.href = 'https://ezamowienia.gov.pl/mo-client-board/bzp/list'
        a.target = '_blank'
        a.click();
    }

    return (
        <GridBlock
            className={classesRoot}
            direction='column'
            alignItems="center"
        >
            {
                isPublishActive || isPublicOjsActive || isOjsProcessing || isBzpPublishActive || isBzpProcessing ?
                    <Icon className={classes.icon} color='primary'/>
                    :
                    <IconOff className={classes.icon} color='primary'/>
            }
            {
                isPublishActive &&
                <Typography variant='h5'>
                    {Tr('congratulations').toUpperCase()}!
                </Typography>
            }

            <Typography variant='body1'>
                {
                    isPublishActive || isPublicOjsActive || isOjsProcessing || isBzpPublishActive || isBzpProcessing ?
                        Tr('p1_pf_1') /*Udało Ci się pomyślnie uzupełnić wszystkie sekcje kreatora postępowania.*/ :
                        (isModification && uncompletedSections.length === 0 ?
                                <>{Tr('p1_pf_1_m_f')} {/*Nie dokonano żadnej modyfikacji lub dokonane zmiany nie wymagają ponownej publikacji postępowania.*/}</>
                                :
                                <>
                                    {Tr('p1_pf_1_f')}{/*Aby przejść do publikacji postępowania wypełnij wymagane sekcje:*/}
                                    {
                                        uncompletedSections.map((x, i) =>
                                            ` "${DemandValidationTr[x]}"${
                                                i === uncompletedSections.length - 1 ? '.' : ','
                                            } `
                                        )}
                                </>
                        )
                }
            </Typography>

            {isPreparing &&
                <Typography variant='body1' align='center'>
                    {Tr('p1_pf_2_1')}{' '} {/*Sprawdź jak Twoje postępowanie będzie wyglądać z perspektywy wykonawcy wybierając przycisk Podgląd.*/}
                    <Box component='span' fontWeight='fontWeightBold'>
                        {Tr('p1_pf_2_2')}{/*Podgląd nie spowoduje jego publikacji.*/}
                    </Box>
                </Typography>
            }
            {isBzpAttachmentNotice && <Typography variant='body1' align='center'>{Tr('bzp_or_ojs_info')}</Typography>}

            {isPreparing &&
                <>
                    {
                        demandHeader.apiVersion < 3 ?
                            <div className={classes.center}>
                                <Button
                                    onClick={() => DemandService.preview(id)}
                                    disabled={!isPreviewActive}
                                >
                                    {Tr('preview')}
                                </Button>
                            </div>
                            : <div className={classes.center}>
                                <Button

                                    onClick={() => DemandService.preview(id)}
                                    disabled={!isPreviewDemandPublicFormActive}
                                >
                                    {Tr("preview_demand_public_form")}
                                </Button>
                                <br/><br/>
                                <Button
                                    onClick={() => NationalNoticeService.printDemandNoticePreview(id)}
                                    disabled={!isPreviewNoticeActive}
                                >
                                    {Tr("preview_notice")}
                                </Button>
                                <br/><br/>
                                <Button
                                    onClick={() => RouterPath.redirect(RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_PREVIEW, {id: id}))}
                                    disabled={!isPreviewActive}
                                >
                                    {Tr("preview_offer_form")}
                                </Button>
                            </div>
                    }
                    {!!section?.competitivenessBaseLink && <div className={classes.center}>
                        <Typography variant='body1' align='center'>
                            {Tr('competitiveness_base.info')}
                        </Typography>
                        <br/>
                        <Button
                            onClick={() => {
                                window.open(section.competitivenessBaseLink, '_blank').focus();
                            }}
                        >
                            {Tr('competitiveness_base.link')}
                        </Button>
                    </div>
                    }
                </>
            }

            {isModification &&
            <>
                {
                    demandHeader.apiVersion >= 3 &&
                        <div className={classes.center}>
                            <Button
                                onClick={() => NationalNoticeService.printDemandNoticePreview(id)}
                                disabled={!isPreviewNoticeActive}
                            >
                                {Tr("preview_notice")}
                            </Button>
                        </div>
                }
            </>
            }

            {isBzpAttachmentNotice &&
                <Button
                    onClick={openBzp}
                >
                    {Tr('bzp_link')}
                </Button>
            }
        </GridBlock>
    )
}

InformationSection.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(InformationSection);